import randomString from "randomstring";

export const Generator = {
  key() {
    return randomString.generate({
      length: 8,
      charset: "alphabetic",
      capitalization: "lowercase",
    });
  },
};
